module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 8,
      "sm": 6,
      "md": 4,
      "lg": 3
    }
  }, [_vm._t("header-logo")], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 16,
      "sm": 18,
      "md": 20,
      "lg": 21
    }
  }, [_vm._t("header-main")], 2)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_vm._t("header-nav")], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5593287c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/HeaderContainer/index.vue
// module id = 739
// module chunks = 3